/// <amd-module name="Environments/RemoteClients/WorkItemTracking" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\environments\vss-environments-web\clients\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as WorkItemTracking from "./Contracts/WorkItemTracking";

export interface IWorkItemTrackingRestClient extends IVssRestClient {
    /**
     * Returns the list of work item types
     * 
     * @param project - Project ID or project name
     */
    getWorkItemTypes(project: string): Promise<WorkItemTracking.WorkItemType[]>;
}

class WorkItemTrackingRestClient extends RestClientBase implements IWorkItemTrackingRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Returns the list of work item types
     * 
     * @param project - Project ID or project name
     */
    public async getWorkItemTypes(
        project: string
        ): Promise<WorkItemTracking.WorkItemType[]> {

        return this.beginRequest<WorkItemTracking.WorkItemType[]>({
            apiVersion: "5.0-preview.2",
            routeTemplate: "{project}/_apis/wit/workItemTypes/{type}",
            routeValues: {
                project: project
            }
        });
    }

}

export const WorkItemTrackingClientName = "Environments-Wit.IWorkItemTrackingRestClient";

export function getWorkItemTrackingClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IWorkItemTrackingRestClient {
    return pageContext.getRestClient<IWorkItemTrackingRestClient>(WorkItemTrackingClientName, options);
}

RestClients.add(WorkItemTrackingClientName, { 
    factory: WorkItemTrackingRestClient,
    options: {
        resourceAreaId: "5264459e-e5e0-4bd8-b118-0985e68a4ec5",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
